var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submitDetailForm.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "grid grid-cols-1 sm:grid-cols-3 gap-8" },
        [
          _c("form-input", {
            attrs: {
              label: "First Name",
              name: "first_name",
              id: "first_name",
              required: true,
              error: _vm.getErrorFor("first_name"),
            },
            model: {
              value: _vm.form.first_name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "first_name", $$v)
              },
              expression: "form.first_name",
            },
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              label: "Last Name",
              name: "last_name",
              id: "last_name",
              required: true,
              error: _vm.getErrorFor("last_name"),
            },
            model: {
              value: _vm.form.last_name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "last_name", $$v)
              },
              expression: "form.last_name",
            },
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              label: "Phone Number",
              name: "phone",
              id: "phone",
              required: true,
              error: _vm.getErrorFor("phone"),
            },
            model: {
              value: _vm.form.phone,
              callback: function ($$v) {
                _vm.$set(_vm.form, "phone", $$v)
              },
              expression: "form.phone",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "sm:col-span-3 text-sm" }, [
            _c(
              "p",
              { staticClass: "text-sm font-medium leading-5 text-gray-700" },
              [
                _vm._v(
                  "\n                We need to provide you with the correct sided feather on your paddle; are you\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex mt-3" },
              [
                _c(
                  "form-radio",
                  {
                    staticClass: "mr-8",
                    attrs: { value: "Right" },
                    model: {
                      value: _vm.form.hand,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "hand", $$v)
                      },
                      expression: "form.hand",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    Right Handed\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "form-radio",
                  {
                    attrs: { value: "Left" },
                    model: {
                      value: _vm.form.hand,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "hand", $$v)
                      },
                      expression: "form.hand",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    Left Handed\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasError("hand")
              ? _c("p", { staticClass: "mt-2 text-xs text-red-600" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getErrorFor("hand")) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sm:col-span-2 text-sm" },
            [
              _c("form-select", {
                attrs: {
                  label:
                    "A lower centre of gravity makes for a more stable kayak; what is your height",
                  options: _vm.heights,
                  "track-by": "value",
                  error: _vm.getErrorFor("height"),
                },
                model: {
                  value: _vm.form.height,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "height", $$v)
                  },
                  expression: "form.height",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sm:col-span-2 text-sm" },
            [
              _c(
                "form-input",
                {
                  attrs: {
                    type: "number",
                    label:
                      "Kayaks have a limited weight capacity; what is your body weight",
                    required: true,
                    error: _vm.getErrorFor("weight"),
                  },
                  model: {
                    value: _vm.form.weight,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "weight", $$v)
                    },
                    expression: "form.weight",
                  },
                },
                [_c("template", { slot: "addOn" }, [_vm._v("kgs")])],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "sm:col-span-3 text-sm" }, [
            _c(
              "p",
              { staticClass: "text-sm font-medium leading-5 text-gray-700" },
              [
                _vm._v(
                  "\n                Basic flexibility allows for a more comfortable and safe experience overall; can you touch your toes\n                with feet at shoulder width?\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex mt-3" },
              [
                _c(
                  "form-radio",
                  {
                    staticClass: "mr-8",
                    attrs: { value: "Yes" },
                    model: {
                      value: _vm.form.flexibility,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "flexibility", $$v)
                      },
                      expression: "form.flexibility",
                    },
                  },
                  [_vm._v("\n                    Yes\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "form-radio",
                  {
                    attrs: { value: "No" },
                    model: {
                      value: _vm.form.flexibility,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "flexibility", $$v)
                      },
                      expression: "form.flexibility",
                    },
                  },
                  [_vm._v("\n                    No\n                ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasError("flexibility")
              ? _c("p", { staticClass: "mt-2 text-xs text-red-600" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getErrorFor("flexibility")) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sm:col-span-3 text-sm" }, [
            _c(
              "p",
              { staticClass: "text-sm font-medium leading-5 text-gray-700" },
              [
                _vm._v(
                  "\n                Previous experience is useful to know for our Guides; have you paddled in deep, tidal water before?\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex mt-3" },
              [
                _c(
                  "form-radio",
                  {
                    staticClass: "mr-8",
                    attrs: { value: "Yes" },
                    model: {
                      value: _vm.form.experience,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "experience", $$v)
                      },
                      expression: "form.experience",
                    },
                  },
                  [_vm._v("\n                    Yes\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "form-radio",
                  {
                    attrs: { value: "No" },
                    model: {
                      value: _vm.form.experience,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "experience", $$v)
                      },
                      expression: "form.experience",
                    },
                  },
                  [_vm._v("\n                    No\n                ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasError("experience")
              ? _c("p", { staticClass: "mt-2 text-xs text-red-600" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getErrorFor("experience")) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sm:col-span-3 text-sm" }, [
            _c(
              "p",
              { staticClass: "text-sm font-medium leading-5 text-gray-700" },
              [
                _vm._v(
                  "\n                Basic core strength and the ability to engage with the activity and environment makes for happier\n                paddlers and a better experience for everyone. What is your perceived fitness level?\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3 grid grid-cols-1 gap-3" },
              [
                _c(
                  "form-radio",
                  {
                    staticClass: "mr-8",
                    attrs: { value: "Sedentary", description: "None at all" },
                    model: {
                      value: _vm.form.core_strength,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "core_strength", $$v)
                      },
                      expression: "form.core_strength",
                    },
                  },
                  [_vm._v("\n                    Sedentary\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "form-radio",
                  {
                    attrs: {
                      value: "Light activity",
                      description: "Short walk the dog once a day",
                    },
                    model: {
                      value: _vm.form.core_strength,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "core_strength", $$v)
                      },
                      expression: "form.core_strength",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    Light activity\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "form-radio",
                  {
                    attrs: {
                      value: "Medium activity",
                      description:
                        "45 minute workout 2-3 times a week with raised heart rate, raised breathing and sweat",
                    },
                    model: {
                      value: _vm.form.core_strength,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "core_strength", $$v)
                      },
                      expression: "form.core_strength",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    Medium activity\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "form-radio",
                  {
                    attrs: {
                      value: "High activity",
                      description:
                        "Intense workouts as above or intense sports such as long distance cycling, running, triathlon, CrossFit et cetera",
                    },
                    model: {
                      value: _vm.form.core_strength,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "core_strength", $$v)
                      },
                      expression: "form.core_strength",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    High activity\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.hasError("core_strength")
                  ? _c("p", { staticClass: "mt-2 text-xs text-red-600" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getErrorFor("core_strength")) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("form-textarea", {
            staticClass: "sm:col-span-2",
            attrs: {
              label:
                "If you are a guest of our 'All Inclusive' fully catered, wild camping event, do you have any dietary requirements?",
              name: "dietary_requirements",
              id: "dietary_requirements",
              error: _vm.getErrorFor("dietary_requirements"),
            },
            model: {
              value: _vm.form.dietary_requirements,
              callback: function ($$v) {
                _vm.$set(_vm.form, "dietary_requirements", $$v)
              },
              expression: "form.dietary_requirements",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "sm:col-span-3 text-sm" }, [
            _c(
              "p",
              { staticClass: "text-sm font-medium leading-5 text-gray-700" },
              [
                _vm._v(
                  "\n                You are obliged as part of your booking process to inform NOMAD Sea Kayaking of any medical\n                conditions, disabilities or phobias that may affect or limit your ability to participate. These\n                include but are not limited to;\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center mt-4" },
              [
                _c("form-toggle", {
                  model: {
                    value: _vm.form.able,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "able", $$v)
                    },
                    expression: "form.able",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "ml-2 text-gray-700" }, [
                  _vm._v(
                    "\n                    I am fit and able to participate in this event\n                "
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasError("able")
              ? _c("div", { staticClass: "ml-12 mt-1 text-xs text-red-600" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getErrorFor("able")) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("form-textarea", {
            staticClass: "sm:col-span-2",
            attrs: {
              label:
                "Please provide all relevant medical information that may affect your ability to participate here",
              name: "medical",
              id: "medical",
              error: _vm.getErrorFor("medical"),
            },
            model: {
              value: _vm.form.medical,
              callback: function ($$v) {
                _vm.$set(_vm.form, "medical", $$v)
              },
              expression: "form.medical",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.forBookingOwner
        ? _c(
            "div",
            {
              staticClass:
                "font-semibold text-gray-600 mt-10 pt-6 text-sm border-t border-gray-200",
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c("form-toggle", {
                    model: {
                      value: _vm.form.marketing_permission,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "marketing_permission", $$v)
                      },
                      expression: "form.marketing_permission",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-2" }, [
                    _vm._v(
                      "\n                Contact me with latest news and offers\n            "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center mt-2" },
                [
                  _c("form-toggle", {
                    model: {
                      value: _vm.form.adult,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "adult", $$v)
                      },
                      expression: "form.adult",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-2" }, [
                    _vm._v(
                      "\n                I confirm that I am at least 18 years of age\n            "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasError("adult")
                ? _c(
                    "div",
                    { staticClass: "ml-12 mt-1 text-xs text-red-600" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.getErrorFor("adult")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center mt-2" },
                [
                  _c("form-toggle", {
                    model: {
                      value: _vm.form.terms,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "terms", $$v)
                      },
                      expression: "form.terms",
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasError("terms")
                ? _c(
                    "div",
                    { staticClass: "ml-12 mt-1 text-xs text-red-600" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.getErrorFor("terms")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex justify-end mt-6" },
        [
          _c("form-button", { attrs: { type: "submit" } }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.forBookingOwner ? "Confirm Details" : "Accept Invitation"
                ) +
                "\n        "
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "ul",
      { staticClass: "leading-5 text-gray-700 list-disc pl-10 mt-4" },
      [
        _c("li", [_vm._v("Diabetes.")]),
        _vm._v(" "),
        _c("li", [_vm._v("Heart conditions.")]),
        _vm._v(" "),
        _c("li", [_vm._v("Epilepsy.")]),
        _vm._v(" "),
        _c("li", [_vm._v("Rheumatism/arthritis.")]),
        _vm._v(" "),
        _c("li", [_vm._v("Back/knee problems &/or shoulder problems.")]),
        _vm._v(" "),
        _c("li", [_vm._v("Hearing and/or site problems.")]),
        _vm._v(" "),
        _c("li", [_vm._v("Seasickness.")]),
        _vm._v(" "),
        _c("li", [_vm._v("Allergies.")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Fears of deep water/swimming or any other relevant phobia/fears."
          ),
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Joint injuries or previous shoulder dislocations.")]),
        _vm._v(" "),
        _c("li", [_vm._v("Deepwater phobias.")]),
        _vm._v(" "),
        _c("li", [_vm._v("The inability to swim.")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Any 'other' disability or condition that may limit or affect your participation in some way."
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ml-2" }, [
      _vm._v("\n                I have read and agree to the "),
      _c(
        "a",
        {
          staticClass: "text-primary-600 hover:underline",
          attrs: { href: "/terms-and-conditions", target: "_blank" },
        },
        [_vm._v("terms and conditions")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }